import React from 'react';
import PageTitle from '../components/pagetitle/PageTitle';
import { Link } from 'react-router-dom';
import { useCart } from '../context/CartContext';
import icon3 from '../assets/images/icon/ethe.svg';

function Cart(props) {
    const { cartItems, removeFromCart, updateQuantity, getCartTotal } = useCart();

    const handleQuantityChange = (itemId, newQuantity) => {
        if (newQuantity >= 1) {
            updateQuantity(itemId, newQuantity);
        }
    };

    if (cartItems.length === 0) {
        return (
            <div>
                <PageTitle none='none' title='Shopping Cart' />
                <section className="tf-add-nft">
                    <div className="tf-container">
                        <div className="row justify-content-center">
                            <div className="col-lg-8">
                                <div className="add-nft-inner" style={{textAlign: 'center', padding: '60px 20px'}}>
                                    <h4 className="title">Your cart is empty</h4>
                                    <p className="sub" style={{marginBottom: '30px'}}>Browse our vouchers and add items to your cart to get started.</p>
                                    <Link to="/dt-shop" className="tf-button active">Browse Vouchers</Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        );
    }

    return (
        <div>
            <PageTitle none='none' title='Shopping Cart' />

            <section className="tf-add-nft">
                <div className="tf-container">
                    <div className="row">
                        <div className="col-lg-8">
                            <div className="add-nft-inner">
                                <h6 className="title">Cart Items ({cartItems.length})</h6>
                                <p className="sub">Review your selected vouchers before checkout.</p>

                                <ul className="collection-list">
                                    {cartItems.map(item => (
                                        <li key={item.id}>
                                            <div className="list" style={{display: 'flex', alignItems: 'center', gap: '20px', padding: '20px 0'}}>
                                                <div className="product-media" style={{width: '100px', height: '100px', borderRadius: '8px', overflow: 'hidden', border: '1px solid #eee'}}>
                                                    <img src={item.image} alt={item.name} style={{width: '100%', height: '100%', objectFit: 'cover'}} />
                                                </div>
                                                <div className="infor" style={{flex: 1}}>
                                                    <p style={{fontSize: '18px', fontWeight: '600', marginBottom: '5px'}}>{item.name}</p>
                                                    <div style={{display: 'flex', alignItems: 'center', gap: '10px'}}>
                                                        <span style={{fontSize: '16px', fontWeight: '600', color: '#FFC107'}}>₹{item.price}</span>
                                                    </div>
                                                </div>
                                                <div style={{display: 'flex', alignItems: 'center', gap: '15px'}}>
                                                    <div style={{display: 'flex', alignItems: 'center', gap: '10px', border: '1px solid #ddd', borderRadius: '8px', padding: '5px 10px'}}>
                                                        <button 
                                                            onClick={() => handleQuantityChange(item.id, item.quantity - 1)}
                                                            style={{background: 'none', border: 'none', fontSize: '18px', cursor: 'pointer', padding: '0 5px'}}
                                                        >
                                                            -
                                                        </button>
                                                        <span style={{minWidth: '30px', textAlign: 'center', fontWeight: '600'}}>{item.quantity}</span>
                                                        <button 
                                                            onClick={() => handleQuantityChange(item.id, item.quantity + 1)}
                                                            style={{background: 'none', border: 'none', fontSize: '18px', cursor: 'pointer', padding: '0 5px'}}
                                                        >
                                                            +
                                                        </button>
                                                    </div>
                                                    <button 
                                                        onClick={() => removeFromCart(item.id)}
                                                        className="tf-button"
                                                        style={{padding: '8px 15px', fontSize: '14px'}}
                                                    >
                                                        Remove
                                                    </button>
                                                </div>
                                            </div>
                                        </li>
                                    ))}
                                </ul>

                                <div className="bottom-button" style={{marginTop: '30px'}}>
                                    <Link to="/dt-shop" className="tf-button">Continue Shopping</Link>
                                </div>
                            </div>
                        </div>

                        <div className="col-lg-4">
                            <div className="add-nft-inner" style={{position: 'sticky', top: '100px'}}>
                                <h6 className="title">Order Summary</h6>
                                
                                <ul className="collection-list">
                                    <li>
                                        <div className="list">
                                            <div className="infor">
                                                <p>Subtotal</p>
                                                <h6>{cartItems.length} item{cartItems.length !== 1 ? 's' : ''}</h6>
                                            </div>
                                            <div>
                                                <h6 style={{fontSize: '18px', fontWeight: '600'}}>₹{getCartTotal().toFixed(2)}</h6>
                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="list">
                                            <div className="infor">
                                                <p>Processing Fee (0.05%)</p>
                                                <h6>0.05% of subtotal</h6>
                                            </div>
                                            <div>
                                                <h6 style={{fontSize: '18px', fontWeight: '600'}}>₹{(getCartTotal() * 0.0005).toFixed(2)}</h6>
                                            </div>
                                        </div>
                                    </li>
                                    <li style={{borderTop: '2px solid #ddd', paddingTop: '15px', marginTop: '15px'}}>
                                        <div className="list">
                                            <div className="infor">
                                                <p style={{fontSize: '18px', fontWeight: '700'}}>Total</p>
                                            </div>
                                            <div>
                                                <h6 style={{fontSize: '24px', fontWeight: '700', color: '#FFC107'}}>₹{(getCartTotal() * 1.0005).toFixed(2)}</h6>
                                            </div>
                                        </div>
                                    </li>
                                </ul>

                                <div className="bottom-button" style={{marginTop: '30px'}}>
                                    <Link to="/checkout" className="tf-button active" style={{width: '100%', textAlign: 'center'}}>
                                        Proceed to Checkout
                                    </Link>
                                </div>

                                <div style={{marginTop: '20px', padding: '15px', background: '#f8f9fa', borderRadius: '8px'}}>
                                    <p style={{fontSize: '14px', color: '#666', margin: 0}}>
                                        <strong>Note:</strong> All vouchers are delivered digitally after successful payment. No refunds once delivered.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
}

export default Cart;
